import React, { useState } from 'react';
import './Login.css';
import api from '../services/api';

const ForgotPassword = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      const response = await api.forgotPassword(email);

      const data = await response.json();

      if (data.ok) {
        setMessage('Password reset instructions have been sent to your email.');
      } else {
        throw new Error(data.message?.[0]?.messages?.[0]?.message || 'Failed to send reset instructions');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="logo">
          <img src="/assets/loginassets/COLA_interface_LogIn_LOGO-03.svg" alt="COLA Logo" />
        </div>
        
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <button type="submit" className="login-button">Send Reset Instructions</button>
          
          <div className="forgot-password">
            <a href="#" onClick={onBack}  >Back to Login</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword; 